import { render } from "./PopUpExo.vue?vue&type=template&id=36501738&scoped=true"
import script from "./PopUpExo.vue?vue&type=script&lang=js"
export * from "./PopUpExo.vue?vue&type=script&lang=js"

import "./PopUpExo.vue?vue&type=style&index=0&id=36501738&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36501738"]])

export default __exports__